import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { BackButtonConfirmationModalModule } from 'src/app/back-button-confirmation-modal/back-button-confirmation-modal.module';

@Component({
    selector: 'app-decision-dialog',
    imports: [BackButtonConfirmationModalModule, MatDialogModule, MatButtonModule],
    templateUrl: './decision-dialog.component.html',
    styleUrl: './decision-dialog.component.scss'
})
export class DecisionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DecisionDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: { type: string; title: string; content: any }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true); 
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
